import React from 'react';
import styled from '@emotion/styled';
const StyledTabButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease-in-out;
  background: transparent;
  font-weight: 500;
  
  flex: 1;
  padding: 0.75rem 0;
  border-radius: 0;
  box-shadow: none;
  
  color: ${(props)=>props.isActive ? props.theme?.primary || 'var(--theme-primary)' : props.theme?.textSecondary || 'var(--theme-text-secondary)'};
  
  border-bottom: ${(props)=>props.isActive ? `2px solid ${props.theme?.primary || 'var(--theme-primary)'}` : 'none'};
  
  &:hover {
    color: ${(props)=>props.isActive ? props.theme?.primary || 'var(--theme-primary)' : props.theme?.text || 'var(--theme-text)'};
    background-color: transparent;
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
/**
 * TabButton 컴포넌트 - 탭 네비게이션에 사용되는 버튼입니다.
 * 
 * 아토믹 디자인의 분자(Molecule) 레벨 컴포넌트
 */ const TabButton = ({ label, icon, isActive, onClick, className = '' })=>{
    return /*#__PURE__*/ React.createElement(StyledTabButton, {
        isActive: isActive,
        onClick: onClick,
        className: className,
        variant: "ghost",
        leftIcon: icon
    }, label);
};
export default TabButton;
